import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';
import MarketingLayout from './components/layout/MarketingLayout';
import PageLoader from './components/common/PageLoader';
import ScrollToTop from './components/ScrollToTop';
import PageTitle from './components/PageTitle';
import SeoStructuredData from './components/SeoStructuredData';

// Code splitting with React.lazy
const Home = React.lazy(() => import('./pages/Home'));
const PlatformCapabilities = React.lazy(() => import('./pages/PlatformCapabilitiesPage'));
const FurtherCapabilities = React.lazy(() => import('./pages/FurtherCapabilities'));
const References = React.lazy(() => import('./pages/References'));
const ReferenceDetail = React.lazy(() => import('./pages/ReferenceDetail'));
const Blog = React.lazy(() => import('./pages/Blog'));
const BlogDetail = React.lazy(() => import('./pages/BlogDetail'));
const ContactUs = React.lazy(() => import('./pages/ContactUs'));
const AboutUs = React.lazy(() => import('./pages/AboutUs'));
const FAQ = React.lazy(() => import('./pages/FAQ'));
const Pricing = React.lazy(() => import('./pages/Pricing'));
const AiIntelligence = React.lazy(() => import('./pages/AiIntelligence'));
const Unsubscribe = React.lazy(() => import('./pages/Unsubscribe'));
const SubscribeConfirm = React.lazy(() => import('./pages/SubscribeConfirm'));
const AppFallback = React.lazy(() => import('./pages/AppFallback'));
const AppRedirect = React.lazy(() => import('./pages/AppRedirect'));

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <PageTitle />
        <SeoStructuredData />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/product-features" element={<PlatformCapabilities />} />
              <Route path="/further-capabilities" element={<FurtherCapabilities />} />
              <Route path="/references" element={<References />} />
              <Route path="/references/:id" element={<ReferenceDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogDetail />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/ai-intelligence" element={<AiIntelligence />} />
              <Route path="/unsubscribe" element={<Unsubscribe />} />
              <Route path="/subscribe/confirm" element={<SubscribeConfirm />} />
            </Route>
            <Route path="/consumer/t/:tenant/app" element={<AppRedirect />} />
            <Route path="/consumer/t/:tenant/*" element={<AppFallback />} />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
